/* eslint-disable max-statements */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-empty-function */
// Disabled until we find out how to define prop types in this case
/* eslint-disable react/prop-types */
import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useLiveChannelsService } from 'LocalGluons/components/ChannelsServiceContext';
import { EpgData, LiveAndNext, modelType, ProgramModel } from '@24i/st-api-connector';
import { useStore } from 'Store';
import { ConfirmationModalContext } from 'LocalGluons/components/ConfirmationModal';
import { isContentBlocked, isContentLocked } from 'Utils/parentalControlUtils';
// eslint-disable-next-line import/no-unresolved
import { getParentalRating, ITEM_TYPES, itemHasEnded, isVod, isLiveTv } from 'Utils';
import { logEvent } from 'AppManager';
// eslint-disable-next-line import/no-unresolved
import { useProgramTimeline } from 'LocalGluons/components/PlayerContainer/services/ProgramTimeline';
import { Device } from 'DeviceUtils';
import throttle from 'lodash.throttle';
import {
    DEFAULT_TV_LIST_WEB_LIMIT,
    DEFAULT_TV_LIST_LIMIT,
    DEFAULT_MINI_EPG_LIST_MODE,
    STREAM_TYPE
} from 'Options';
import { playerModalsEnum } from 'LocalGluons/components/PlayerUI/components/PlayerModal';
import type { PlayerData, StreamData, UnixTimeMs } from 'Types';
import { PlayerManager } from '@24i/react-native-player';
import { useNavigation } from '@react-navigation/native';
import NavigationService from 'NavigationService';
import { ConfirmationModal } from 'LocalGluons';
// import epgUtils from 'Utils/epgUtils';

const LIVE_RANGE_OFFSET = 21600000; // 6 hours in MS

const findItemWithoutBlackout = async (
    previous = false,
    returnIndex = false,
    programs,
    currentProgramIndex,
    api,
    onApi = false
) => {
    for (
        let i = previous ? currentProgramIndex - 1 : currentProgramIndex + 1;
        previous ? i >= 0 : i < programs.length;
        previous ? i-- : i++
    ) {
        let newItem;
        if (onApi) {
            // eslint-disable-next-line no-await-in-loop
            newItem = await api.fetchProgramDetail({
                scheduleId: programs[i].getId()
            });
        } else {
            newItem = programs[i];
        }
        if (!newItem.hasBlackout()) {
            return returnIndex ? i : newItem;
        }
    }
    return false;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useLivePlayer = (
    item: PlayerData['item'],
    changeItem: (
        item: PlayerData['item'],
        shouldRewindToStart?: boolean,
        isLiveRecording?: boolean
    ) => void,
    itemStreamData: StreamData,
    onBack: (() => void) | undefined,
    isModalBinge: boolean,
    setModalType: React.Dispatch<React.SetStateAction<playerModalsEnum | null>>,
    player: PlayerManager,
    onPlayerProgress?: (progressDataObject: any) => void
) => {
    const {
        isInitialized: liveChannelsServiceIsInitialized,
        channels,
        getChannel,
        setChannelData,
        channelsAreLoading,
        initialize: initializeLiveChannelsService,
        reset: resetLiveChannelsService,
        refreshChannels
    } = useLiveChannelsService();
    const { appManager, parentalLockConfig, setPlayerData } = useStore();
    const { setProtectedContent, setModalContent } = useContext(ConfirmationModalContext);
    const { streamType, maxTimeshift = 0 } = itemStreamData;
    const api = appManager.getApi();
    const navigation = NavigationService.getAppNavigationInstance();
    const programTimeline = useProgramTimeline(api, item.getChannelId());
    // Live item is used later for recording stuff. Only item downloaded as detail has rec metadata
    const timeout = useRef(null);
    const [liveItem, setLiveItem] = useState(item);
    const [loading, setLoading] = useState(false);
    const [shouldFetchLive, setShouldFetchLive] = useState<'no' | 'yes' | 'fetching'>('no');
    const { setContinueWatchingEnabled } = useStore();
    const [nextItem, setNextItem] = useState<ProgramModel | undefined>();
    const [previousItem, setPreviousItem] = useState<ProgramModel | undefined>();
    const [archiveAvailable, setArchiveAvailable] = useState<boolean>(false);
    const [validPin, setValidPin] = useState<boolean>(false);

    const [isVideoBlocked, setVideoBlocked] = useState(false);

    useEffect(
        () => () => {
            clearTimeout(timeout?.current);
        },
        []
    );

    const handleParentalCheck = useCallback(
        (itemToCheck, onSuccess = () => { }) => {
            const adultLock = isContentLocked(itemToCheck.isAdult(), parentalLockConfig);
            const ageBlock = isContentBlocked(
                getParentalRating(itemToCheck.data),
                parentalLockConfig
            );

            const successCallback = () => {
                setModalContent(null);
                setVideoBlocked(false);
                onSuccess();
            };
            const closeCallback = (isPinValid: boolean) => {
                setModalContent(null);
                if (!isPinValid && typeof onBack === 'function') onBack();
            };
            const forgotPinCallback = () => {
                if (typeof onBack === 'function') onBack();
            };

            if (ageBlock || adultLock) {
                setVideoBlocked(true);
                setTimeout(() => {
                    setVideoBlocked(true);
                    setProtectedContent(
                        itemToCheck,
                        successCallback,
                        true,
                        closeCallback,
                        forgotPinCallback,
                        true
                    );
                }, 500);
            } else {
                onSuccess();
            }
        },
        [onBack, parentalLockConfig, setModalContent, setProtectedContent]
    );

    // useEffect(() => {
    //     const fetchPrograms = async () => {
    //         if (streamType === STREAM_TYPE.TIMESHIFT || streamType === STREAM_TYPE.LIVE) {
    //             const now = Date.now();
    //             await programTimeline.fetchPrograms(now - maxTimeshift * 1000, now);
    //         }
    //     };

    //     fetchPrograms();
    // }, [maxTimeshift, programTimeline, streamType]);

    const fetchChannel = useCallback(async () => {
        if (
            (streamType === STREAM_TYPE.ARCHIVE || streamType === STREAM_TYPE.LIVE) &&
            'getStartTime' in item &&
            'getEndTime' in item
        ) {
            const params = {
                from: item.getStartTime() - LIVE_RANGE_OFFSET,
                to: item.getEndTime() + LIVE_RANGE_OFFSET,
                limit: 1000,
                channelIds: `${item.getChannelId()}`
            };
            const { items } = (await api.fetchEpg(params)) as EpgData;

            const channel = items.find(
                (channelItem) => channelItem.channel.channelId === item.getChannelId()
            );

            return channel;
        }
        return null;
    }, [api, item, streamType]);

    useEffect(() => {
        const fetchPrograms = async () => {
            const channel = await fetchChannel();

            if (!channel || !channel.channel.hasArchive) {
                setArchiveAvailable(false);
                setPreviousItem(undefined);
                setNextItem(undefined);
                return;
            }

            setArchiveAvailable(true);

            const currentProgramIndex = channel.programs.findIndex(
                (program) => program.getId() === item.getId()
            );

            const nextItemIndex = await findItemWithoutBlackout(
                false,
                true,
                channel.programs,
                currentProgramIndex,
                api
            );

            const previousItemIndex = await findItemWithoutBlackout(
                true,
                true,
                channel.programs,
                currentProgramIndex,
                api
            );

            if (
                nextItemIndex &&
                channel.programs[nextItemIndex].getScheduleStatus() !== 'future' &&
                streamType === STREAM_TYPE.ARCHIVE &&
                channel.programs[nextItemIndex] &&
                channel.channel.hasArchive &&
                (channel.programs[nextItemIndex].getScheduleStatus() === 'archive' ||
                    channel.programs[nextItemIndex].hasArchive() ||
                    isLiveTv(channel.programs[nextItemIndex]))
            )
                setNextItem(channel.programs[nextItemIndex]);
            else setNextItem(undefined);

            if (
                previousItemIndex &&
                channel.programs[previousItemIndex] &&
                (channel.programs[previousItemIndex].getScheduleStatus() === 'archive' ||
                    channel.programs[previousItemIndex].hasArchive())
            )
                setPreviousItem(channel.programs[previousItemIndex]);
            else setPreviousItem(undefined);
        };

        fetchPrograms();
    }, [api, item, streamType]);

    const switchToLive = async () => {
        setContinueWatchingEnabled(false);
        setLoading(true);
        if (isModalBinge) {
            setModalType(null);
        }
        const newLiveItem = await api.fetchProgramDetail({
            channelId: item.getChannelId()
        });
        changeItem(newLiveItem);
    };
    const playNextItem = useMemo(
        () =>
            nextItem
                ? async () => {
                    if (nextItem) {
                        setContinueWatchingEnabled(false);
                        setLoading(true);
                        if (isModalBinge) {
                            setModalType(null);
                        }
                        try {
                            const newItem = await api.fetchProgramDetail({
                                scheduleId: nextItem.getId()
                            });

                            if (newItem?.hasBlackout && newItem?.hasBlackout()) {
                                const channel = await fetchChannel();
                                if (channel && channel.channel.hasArchive) {
                                    const currentProgramIndex = channel.programs.findIndex(
                                        (program) => program.getId() === item.getId()
                                    );

                                    const newNextItem = await findItemWithoutBlackout(
                                        false,
                                        false,
                                        channel.programs,
                                        currentProgramIndex,
                                        api,
                                        true
                                    );

                                    if (
                                        newNextItem &&
                                        newNextItem &&
                                        (newNextItem.getScheduleStatus() === 'archive' ||
                                            newNextItem.hasArchive())
                                    ) {
                                        setNewCurrentItem(newNextItem);
                                        logEvent({
                                            type: 'user-flow',
                                            subtype: 'player',
                                            content1: 'maxiplayer',
                                            content2: 'previous-asset',
                                            context: '/player'
                                        });
                                        return;
                                    }
                                }
                            }

                            setNewCurrentItem(newItem, false, true);
                            logEvent({
                                type: 'user-flow',
                                subtype: 'player',
                                content1: 'maxiplayer',
                                content2: 'next-asset',
                                context: '/player'
                            });
                        } catch (e) {
                            setNewCurrentItem(nextItem, false, true);
                        }
                    }
                }
                : null,
        [nextItem, changeItem]
    );

    const playPreviousItem = useMemo(
        () =>
            previousItem
                ? async () => {
                    if (previousItem) {
                        setContinueWatchingEnabled(false);
                        setLoading(true);
                        if (isModalBinge) {
                            setModalType(null);
                        }
                        try {
                            const newItem = await api.fetchProgramDetail({
                                scheduleId: previousItem.getId()
                            });

                            if (newItem?.hasBlackout && newItem?.hasBlackout()) {
                                const channel = await fetchChannel();
                                if (channel && channel.channel.hasArchive) {
                                    const currentProgramIndex = channel.programs.findIndex(
                                        (program) => program.getId() === item.getId()
                                    );
                                    const newPreviousItem = await findItemWithoutBlackout(
                                        true,
                                        false,
                                        channel.programs,
                                        currentProgramIndex,
                                        api,
                                        true
                                    );

                                    if (
                                        newPreviousItem &&
                                        newPreviousItem &&
                                        (newPreviousItem.getScheduleStatus() === 'archive' ||
                                            newPreviousItem.hasArchive())
                                    ) {
                                        changeItem(newPreviousItem);
                                        logEvent({
                                            type: 'user-flow',
                                            subtype: 'player',
                                            content1: 'maxiplayer',
                                            content2: 'previous-asset',
                                            context: '/player'
                                        });
                                        return;
                                    }
                                }
                            }

                            changeItem(newItem);
                            logEvent({
                                type: 'user-flow',
                                subtype: 'player',
                                content1: 'maxiplayer',
                                content2: 'previous-asset',
                                context: '/player'
                            });
                        } catch (e) {
                            changeItem(previousItem);
                        }
                    }
                }
                : null,
        [previousItem, changeItem]
    );

    const protectedContentGesture = async (
        itemToCheck: unknown,
        successCallback: { (): void; (): void },
        closeCallback: { (isPinValid: boolean): void; (arg0: boolean): void },
        forgotPinCallback: { (): void; (): void }
    ) => {
        setVideoBlocked(true);
        setProtectedContent(
            itemToCheck,
            successCallback,
            true,
            () => closeCallback(validPin),
            forgotPinCallback,
            true
        );
    };

    const checkParentalForGesture = async (itemToCheck) => {
        const adultLock = isContentLocked(itemToCheck.isAdult(), parentalLockConfig);
        const ageBlock = isContentBlocked(getParentalRating(itemToCheck.data), parentalLockConfig);

        const successCallback = () => {
            setModalContent(null);
            setVideoBlocked(false);
            changeItem(itemToCheck);
            setValidPin(true);
        };
        const closeCallback = (isPinValid: boolean) => {
            if (!isPinValid && typeof onBack === 'function') {
                setModalContent(null);
            }
        };
        const forgotPinCallback = () => {
            if (typeof onBack === 'function') onBack();
        };
        if (ageBlock || adultLock) {
            setVideoBlocked(true);
            await protectedContentGesture(
                itemToCheck,
                successCallback,
                closeCallback,
                forgotPinCallback
            );
        } else {
            changeItem(itemToCheck);
        }
    };

    const onHorizontalGesture = useCallback(
        throttle(async (gestureDirection) => {
            if (!isLiveTv(item)) return;
            try {
                if (!channelsAreLoading) {
                    let offset = 0;
                    const getRefreshedItem = async () => {
                        let channelData: LiveAndNext = (await getChannel(
                            Math.round(gestureDirection),
                            channels,
                            offset
                            // TODO: Remove this after Channel Service Context TS Refactor
                        )) as unknown as LiveAndNext;
                        const { live } = channelData;
                        let modeledSelectedItem = new ProgramModel(live);
                        const liveItemEnded = itemHasEnded(modeledSelectedItem);
                        // If some live has ended we should update channels
                        if (liveItemEnded) {
                            const refreshedChannels = await refreshChannels();
                            channelData = (await getChannel(
                                Math.round(gestureDirection),
                                refreshedChannels
                                // TODO: Remove this after Channel Service Context TS Refactor
                            )) as unknown as LiveAndNext;
                            // Eslint want destructuring here. how?
                            // eslint-disable-next-line prefer-destructuring
                            modeledSelectedItem = new ProgramModel(channelData.live);
                        }
                        const newItem = await appManager.getApi().fetchProgramDetail({
                            scheduleId: modeledSelectedItem.getId()
                        });

                        if (newItem?.hasBlackout && newItem?.hasBlackout()) {
                            offset += Math.round(gestureDirection);
                            return getRefreshedItem();
                        }

                        return newItem;
                    };

                    const refreshedItem = await getRefreshedItem();
                    logEvent({
                        type: 'navigation',
                        subtype: 'channelChange',
                        content1: item.getChannelId(),
                        content2: refreshedItem.getChannelId()
                    });
                    checkParentalForGesture(refreshedItem);
                }
            } catch (error) {
                console.log('HorizontalGesture catch: ', error);
            }
        }, 400),
        [itemHasEnded, refreshChannels, getChannel, changeItem, item]
    );

    const setNewCurrentItem = useCallback(
        (newCurrentItem, setAlsoAsLiveItem = false, rewind = false, isLiveRecording = false) => {
            handleParentalCheck(newCurrentItem, () => {
                changeItem(newCurrentItem, rewind, isLiveRecording);
                if (setAlsoAsLiveItem) setLiveItem(newCurrentItem);
            });
        },
        [changeItem, handleParentalCheck]
    );

    const refreshDetailItem = async (isLiveRecording = false) => {
        // check if this is a live recording
        try {
            const updatedItem = await appManager.getApi().fetchProgramDetail({
                scheduleId: item.getId()
            });
            setNewCurrentItem(updatedItem, true, false, streamType === STREAM_TYPE.ARCHIVE);
        } catch (error) {
            console.log(error);
        }
    };

    const onProgress = async (progressDataObject: { progressData: { currentTime: number } }) => {
        if (loading) return;
        if (item.modelType !== ITEM_TYPES.TV || !('getProgramId' in item)) return;
        const {
            progressData: { currentTime }
        } = progressDataObject;
        if (typeof onPlayerProgress === 'function') onPlayerProgress(progressDataObject);

        const shouldFetchLiveCond =
            player?.getUTCTimestamp(currentTime).getTime() >= item.getEndTime();

        if (shouldFetchLiveCond && shouldFetchLive === 'no' && streamType === STREAM_TYPE.LIVE) {
            setShouldFetchLive('yes');
        }
    };

    const fetchLive = async () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(
            async () => {
                const newLiveItem = await api.fetchProgramDetail({
                    channelId: item.getChannelId()
                });
                const currentTimestamp = new Date().getTime();
                if (
                    newLiveItem.getStartTime() <= currentTimestamp &&
                    currentTimestamp < newLiveItem.getEndTime()
                ) {
                    if (newLiveItem.hasBlackout && newLiveItem.hasBlackout()) {
                        navigation.push('Details', { id: newLiveItem.getId(), type: newLiveItem.modelType });
                        setPlayerData(null);
                        return;
                    }
                    setNewCurrentItem(newLiveItem, true);
                } else {
                    timeout.current = setTimeout(() => {
                        setShouldFetchLive('yes');
                    }, 1000);
                }
            },
            Device.isIos ? 1500 : 100
        );
    };

    useEffect(() => {
        if (shouldFetchLive === 'yes') {
            setShouldFetchLive('fetching');
        }
        if (shouldFetchLive === 'fetching') {
            fetchLive();
        }
    }, [shouldFetchLive]);

    const onResumePlaying = async (currentTime: UnixTimeMs) => {
        if (streamType !== STREAM_TYPE.LIVE || !('getProgramId' in item)) {
            // TODO: ...
        }
    };

    useEffect(() => {
        setShouldFetchLive('no');
        if (item.modelType !== ITEM_TYPES.TV || !('getStartTime' in item)) return;

        setChannelData(item.getChannelId(), item.getStartTime());
        initializeLiveChannelsService({
            list: DEFAULT_MINI_EPG_LIST_MODE,
            limit: Device.isWeb ? DEFAULT_TV_LIST_WEB_LIMIT : DEFAULT_TV_LIST_LIMIT
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);

    const onPlayerBack = () => {
        resetLiveChannelsService();
        if (onBack) onBack();
    };

    return {
        isVideoBlocked,
        onHorizontalGesture,
        liveItem,
        refreshDetailItem,
        onProgress,
        onBack: onPlayerBack,
        loading: Boolean((liveChannelsServiceIsInitialized && channelsAreLoading) || loading),
        onResumePlaying,
        playNextItem,
        playPreviousItem,
        archiveAvailable,
        switchToLive,
        liveLoading: loading,
        setLiveLoading: setLoading,
        nextItem,
        setNewCurrentItem
    };
};

export default useLivePlayer;
